import React from "react";
import { Alert } from "@material-ui/lab";
import { StyledScrollTable, StyledTable, StyledTableBody, StyledTableHead } from "../../../styles/styledTable";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import TelegramBotsItem from "./TelegramBotsItem";

const TelegramBotsList = ({ bots, onDelete, t }) => {
  if (bots === null) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (bots.length === 0) {
    return <Alert severity="warning">{t("bots.table.emptyData")}</Alert>;
  }

  return (
    <StyledScrollTable>
      <StyledTable width="600" size="14" className="bot-list">
        <StyledTableHead scroll="auto" col="3" className="bot-list__head">
          <div>{t("bots.table.project")}</div>
          <div>{t("bots.table.token")}</div>
          <div>{t("bots.table.actions")}</div>
        </StyledTableHead>
        <StyledTableBody>
          {bots.map(bot => (
            <TelegramBotsItem key={bot.projectId} bot={bot} onDelete={onDelete} t={t} />
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};

export default TelegramBotsList;